"use server"

import { sdk } from "@lib/config"

export const subscribeNewsletter = async (
  email: string
): Promise<{ subscribed: boolean }> => {
  try {
    const { subscribed } = await sdk.client.fetch<{ subscribed: boolean }>(
      `/store/newsletter`,
      {
        method: "POST",
        body: { email },
        cache: "no-store",
      }
    )

    return { subscribed: Boolean(subscribed) }
  } catch {
    return { subscribed: false }
  }
}
